import { InlineLinkWrapper } from './InlineLink.styles'

interface InlineLinkProps {
  variant?: 'default' | 'danger'
  children: React.ReactNode
  onClick?: () => void
}

const InlienLink = ({ variant = 'default', children, onClick }: InlineLinkProps) => {
  return (
    <InlineLinkWrapper variant={variant} onClick={onClick}>
      {children}
    </InlineLinkWrapper>
  )
}

export default InlienLink
